import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import ApiService from '../util/ApiService';
import Swal from 'sweetalert2';

const typeOptions = [
    { value: 1, label: "Física" },
    { value: 2, label: "Jurídica" }
];

const DocEditModal = ({ show, onHide, doc, ufs, onSaveSuccess }) => {
    const [docTypeData, setDocTypeData] = useState(null);
    const [docNumber, setDocNumber] = useState('');
    const [selectedUf, setSelectedUf] = useState(null);
    const [typeOfPerson, setTypeOfPerson] = useState(null);
    const [file, setFile] = useState(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (doc && show) {
            setDocNumber(doc.doc_number || '');
            setSelectedUf(ufs.find(uf => uf.value === doc.state));
            setTypeOfPerson(
                doc.type_of_person
                    ? { value: doc.type_of_person, label: doc.type_of_person === 1 ? "Física" : "Jurídica" }
                    : null
            );

            // Buscar config do tipo de doc
            ApiService.send("get", process.env.REACT_APP_URL_API + "documents/type-docs-id", { id: doc.id_type })
                .then(response => {
                    const { data } = ApiService.handleApiResponse(response);
                    setDocTypeData(data);
                })
                .catch(ApiService.handleApiError);
        }
    }, [doc, show]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);

        const formData = new FormData();
        formData.append("file", file || "");
        formData.append("doc_number", docNumber);
        formData.append("state", selectedUf?.value || "");
        formData.append("id_type", doc.id_type || "");
        formData.append("id", doc.id || "");
        formData.append("type_of_person", typeOfPerson?.value || "");

        try {
            const response = await ApiService.sendArquivo('post', process.env.REACT_APP_URL_API + 'doc/register', formData);
            if (response.code === 200) {
                Swal.fire('Sucesso!', 'Documento salvo com sucesso.', 'success');
                onSaveSuccess(); // Atualizar lista
                onHide();
            } else {
                throw new Error(response?.data?.message);
            }
        } catch (err) {
            ApiService.handleApiError(err);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Cadastro Documento - {docTypeData?.name || ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    {docTypeData?.visible_value === 1 && (
                        <Form.Group className="mb-3">
                            <Form.Label>Número</Form.Label>
                            <Form.Control
                                type="text"
                                value={docNumber}
                                onChange={(e) => setDocNumber(e.target.value)}
                            />
                        </Form.Group>
                    )}

                    {docTypeData?.visible_state === 1 && (
                        <Form.Group className="mb-3">
                            <Form.Label>Estado</Form.Label>
                            <Select
                                value={selectedUf}
                                onChange={setSelectedUf}
                                options={ufs}
                                placeholder="Selecione o estado"
                            />
                        </Form.Group>
                    )}

                    {docTypeData?.visible_type_of_person === 1 && (
                        <Form.Group className="mb-3">
                            <Form.Label>Tipo</Form.Label>
                            <Select
                                value={typeOfPerson}
                                onChange={setTypeOfPerson}
                                options={typeOptions}
                                placeholder="Selecione o tipo"
                            />
                        </Form.Group>
                    )}

                    {docTypeData?.visible_file === 1 && (
                        <Form.Group className="mb-3">
                            <Form.Label>Arquivo</Form.Label>
                            <Form.Control
                                type="file"
                                name="document_file"
                                onChange={(e) => setFile(e.target.files[0])}
                            />
                            <Form.Text className="text-muted">Apenas arquivos PDF</Form.Text>
                        </Form.Group>
                    )}
                    <Button type="submit" variant="primary" disabled={saving}>
                        {saving ? "Salvando..." : "Salvar Documento"}
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default DocEditModal;
